import component from "./components";
import StudentProgressReport from "ProgressReport/routes/ProgressReportDetails/routes/StudentProgressReport";
import StudentReflectionReport from "./routes/StudentReflectionReport";

export default store => ({
  path: "progress-report",
  component,
  childRoutes: [StudentReflectionReport(store), StudentProgressReport(store)],
});
